import React from 'react';
import { Link } from 'react-router-dom';
export function Home() {
  return <div className="min-h-screen bg-paper flex flex-col items-center justify-center gap-8" data-id="element-124">
      <h1 className="text-6xl md:text-8xl text-ink" data-id="element-125">kan family</h1>
      <Link to="/reunion" className="text-lg text-terracotta hover:underline underline-offset-4 transition-colors" data-id="element-126">
        reunion
      </Link>
    </div>;
}